import styled from '@emotion/styled'
import { MediaQueries } from '@hhgtech/hhg-components/misc'

export const StyledInfo = styled.div`
  ${MediaQueries.mbUp} {
    padding-left: 16px;
    padding-right: 16px;
  }

  padding-bottom: 60px;
  &.baby-growth {
    padding-bottom: 0;
  }
`

export const StyledBMIInfo = styled.div`
  & > :not(:last-child) {
    margin-bottom: 28px;
  }
`

export const StyledChart = styled.div`
  margin-bottom: 32px;

  ${MediaQueries.mbUp} {
    padding-left: 16px;
    padding-right: 16px;
  }
`

export const StyledInfoCard = styled.div`
  padding-top: 32px;

  & > div {
    margin-bottom: 24px;
  }

  ${MediaQueries.mbUp} {
    padding-left: 16px;
    padding-right: 16px;
  }
`

export const StyledRecordHeading = styled.div`
  margin: 32px 0 10px 0;
`

export const StyledBackIcon = styled.img`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 24px;
  height: 24px;
  margin: auto;
  cursor: pointer;
`
